import { Button, Text } from '@mantine/core';

import { Link } from 'react-router-dom';

const ForgotPasswordResetSuccess = () => {
  return (
    <>
      <Text fz="2rem" fw="bold" mt="md">
        You're all set!
      </Text>
      <Text>Use your new Fooda password to log in to Fooda for Restaurants.</Text>
      <Button mt="sm" size="lg" fullWidth component={Link} to="/login">
        Go to Login
      </Button>
    </>
  );
};

export default ForgotPasswordResetSuccess;
